import { createEditor } from "@wangeditor/editor";

class FormatPaint {
  constructor() {
    this.title = "格式刷"; // 自定义菜单标题
    this.iconSvg =
      '<svg class="icon" style="width: 1.5em;height: 1.5em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3969"><path d="M678.656 141.013333a93.866667 93.866667 0 0 1 108.373333 17.621334l78.421334 78.421333a93.866667 93.866667 0 0 1-0.042667 132.693333l-84.48 84.48 45.312 45.312a128.085333 128.085333 0 0 1 5.717333 174.805334l-5.76 6.144-120.618666 120.746666-0.085334-0.042666-90.453333 90.496a128 128 0 0 1-174.933333 5.76l-6.101334-5.76L132.266667 590.08a128 128 0 0 1 0-181.034667l90.453333-90.538666 120.746667-120.746667a128 128 0 0 1 180.992 0.085333l45.269333 45.226667 89.344-89.258667 13.354667-9.642666zM301.226667 396.928a25.6 25.6 0 0 0-36.181334 0L192.64 469.333333l-3.541333 4.010667a42.666667 42.666667 0 0 0 3.541333 56.32l301.653333 301.653333 4.053334 3.584a42.666667 42.666667 0 0 0 56.32-3.541333l72.405333-72.405333a25.6 25.6 0 0 0 0-36.181334z m423.253333-179.626667a8.533333 8.533333 0 0 0-7.68 0l-2.176 1.621334-144.853333 144.810666-105.6-105.6-4.010667-3.541333a42.666667 42.666667 0 0 0-56.32 3.541333l-42.24 42.24a25.6 25.6 0 0 0 0 36.181334l325.845333 325.888 3.541334 2.986666a25.6 25.6 0 0 0 32.64-2.986666l42.24-42.24 3.498666-4.053334c13.013333-16.725333 11.818667-40.96-3.541333-56.32l-105.557333-105.6 144.810666-144.810666 1.578667-2.176a8.533333 8.533333 0 0 0-1.578667-9.856L726.613333 218.88z" fill="#5D6E7F" p-id="3970"></path></svg>'; // 可选
    this.tag = "button";
    if (!FormatPaint.prototype.init) {
      FormatPaint.prototype.attrs = {
        isSelect: false,
        formatJson: {},
        formatedHtml: "",
      };
      FormatPaint.prototype.init = true;
    }
  }
  getValue() {
    // JS 语法
    return "";
  }

  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive() {
    return this.attrs.isSelect;
  }

  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled() {
    // JS 语法
    return false;
  }

  // 点击菜单时触发的函数
  exec(editor) {
    if (this.isDisabled(editor)) return;
    const select = editor.getFragment()[0].children[0];
    if (!this.attrs.isSelect && select.text.length) {
      this.attrs.formatJson = { ...select };
      this.attrs.isSelect = true;
    } else {
      editor.getSelectionText();
      this.attrs.isSelect = false;
    }
    editor.blur();
    editor.focus(); // JS 语法
  }
  //设置格式化好的内容
  setFormatHtml(editor) {
    if (!this.attrs.formatedHtml.length) return;
    editor.dangerouslyInsertHtml(this.attrs.formatedHtml);
    this.attrs.formatedHtml = "";
  }
}

export function withSelect(editor) {
  const myFormatPaint = new FormatPaint();

  const { onChange } = editor; // 获取当前 editor API
  const newEditor = editor;

  newEditor.onChange = () => {
    onChange();
    if (myFormatPaint.attrs.isSelect) {
      myFormatPaint.attrs.formatJson.text = newEditor.getSelectionText();
      const _editor = createEditor({
        content: [myFormatPaint.attrs.formatJson],
      });
      myFormatPaint.attrs.formatedHtml = _editor.getHtml();
      if (!document.onmouseup) {
        document.onmouseup = () => {
          if (!myFormatPaint.attrs.formatedHtml.length) return;
          myFormatPaint.setFormatHtml(newEditor);
          document.onmouseup = null;
        };
      }
    }
    return;
  };
  return newEditor;
}

const FormatPaintMenuConf = {
  key: "FormatPaintMenuConf", // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new FormatPaint(); // 把 `YourMenuClass` 替换为你菜单的 class
  },
};
export default FormatPaintMenuConf;
